import { Link } from 'react-router-dom';
import type { ArticleCard } from '@nk/shared';
import { useLocale } from '@/i18n/locale-context';
import { formatDate } from '@/lib/format';
import { ArticleImage, ArticleMiniCard } from '@/components/content';

/** PRD §11: one large feature, then its supporting stories. */
export function CultureBlock({
  feature,
  supporting,
}: {
  feature: ArticleCard | null;
  supporting: ArticleCard[];
}) {
  const { locale, t } = useLocale();

  if (!feature) return null;

  return (
    <div>
      <Link to={feature.path} className="group relative block overflow-hidden rounded-xl">
        <ArticleImage
          image={feature.image}
          alt={feature.headline}
          sizes="(max-width: 1080px) 100vw, 40vw"
          aspect="aspect-[5/4]"
          placeholderSeed={feature.category.slug}
          className="h-full w-full"
        />
        <span
          aria-hidden="true"
          className="absolute inset-0 bg-[linear-gradient(0deg,rgba(15,18,22,.75),rgba(15,18,22,.05)_60%)]"
        />
        <span className="absolute inset-x-5 bottom-4 z-10">
          <span className="mb-2 inline-block rounded-xs bg-white px-2 py-1 text-2xs font-extrabold uppercase tracking-wider text-red">
            {feature.category.name}
          </span>
          <span className="block max-w-[300px] text-3xl font-extrabold text-white">
            {feature.headline}
          </span>
          <span className="mt-2 block text-xs text-[#e2e4e6]">
            {formatDate(feature.publishedAt, locale)} ·{' '}
            {t('meta.readTime', { minutes: feature.readingMinutes })}
          </span>
        </span>
      </Link>

      {supporting.length > 0 && (
        <div className="mt-3">
          {supporting.map((article) => (
            <ArticleMiniCard key={article.id} article={article} />
          ))}
        </div>
      )}
    </div>
  );
}
